import { STUDENT_DETAIL_ROUTES } from "../../modules/constants";
import StudentTranscriptPreview from "./components";

export default () => ({
  path: STUDENT_DETAIL_ROUTES.PREVIEW_TRANSCRIPTS,
  component: StudentTranscriptPreview,
});
